const commonMixin = {
  data() {
    return {
      textCopied: false,
    };
  },
  computed: {
    getDateTimeForFileName() {
      const date = new Date();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const year = date.getFullYear();
      const hour = date.getHours();
      const minute = String(date.getMinutes()).padStart(2, "0");
      const ampm = hour >= 12 ? "pm" : "am";
      const hour12 = String(hour % 12 || 12).padStart(2, "0");

      return `${month}-${day}-${year}_${hour12}-${minute}${ampm}`;
    },
  },
  methods: {
    async copyToClipboard(text) {
      // Clear any existing timeout to prevent issues with multiple clicks
      if (this.copyTimeout) {
        clearTimeout(this.copyTimeout);
      }

      try {
        await navigator.clipboard.writeText(text);
        this.textCopied = true;

        // Store the timeout ID so it can be cleared if needed
        this.copyTimeout = setTimeout(() => {
          this.textCopied = false;
          this.copyTimeout = null;
        }, 500);

        // Show success message
        this.$store.commit("setToastData", {
          message: "Copied to clipboard",
          color: "success",
          snackbar: true,
        });
      } catch (err) {
        console.error("Failed to copy text to clipboard:", err);

        // Show error message instead of success message on failure
        this.$store.commit("setToastData", {
          message: "Failed to copy to clipboard",
          color: "error",
          snackbar: true,
        });

        this.textCopied = false;
      }
    },

    formattedDate(date) {
      let dateToFormat = new Date(date);
      return dateToFormat.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },

    formatDateTimeLocal(dateString) {
      if (!dateString) return "--";

      const date = new Date(dateString);
      return date
        .toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        })
        .replace(",", ",");
    },
  },
};
export default commonMixin;
